<template>
  <div class="shopmall">
    <div class="shopmall-background" @scroll="BaCoScrollqb($event)">
      <div class="shopmall-backmap">
        <div class="shopmall-search">
          <div class="shopmall-search-relvus">
            <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
          </div>
          <router-link :to="{path: 'seaducts'}">
            <div class="shopmall-search-retval">
              <img src="../../public/obraoag/serch.png" alt="">
              <input type="text" placeholder="请输入关键词" disabled>
            </div>
          </router-link>
        </div>
        <div class="shopmall-rotaon">
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide v-for="item in shtaorin" :key= item.ID>
              <router-link :to="{path:'commodity',query: {hmComyID: item.PARENT_ID}}" v-if="item.PARENT_ID"><img :src="item.IMAGE_URL" alt=""></router-link>
              <img :src="item.IMAGE_URL" alt="" v-else>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="shopmall-rolars">
          <div class="shopmall-casion">
            <router-link :to="{path: 'modtyatn',query: {shodtyID: ershmodtya.ID}}" v-for="ershmodtya in shmodtya" :key="ershmodtya.ID">
              <div class="shopmall-casion-edcaon">
                <img :src="ershmodtya.TYPE_IMG" alt="">
                <p>{{ershmodtya.MENU_NAME}}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="shopmall-comity">
          <div class="shopmall-comity-content" v-for="ershcomdty in shcomdty" :key="ershcomdty.ID">
            <router-link :to="{path:'commodity',query: {hmComyID: ershcomdty.ID}}">
              <img :src="ershcomdty.GOODS_IMAGE" alt="">
              <p class="shopmall-comity-content-test">{{ershcomdty.GOODS_NAME}}</p>
              <p class="shopmall-comity-content-nimber">{{ershcomdty.MARKET_PRICE}}<span>元</span></p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <botgaion snatus="1"></botgaion>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      shtaorin: '',
      shcomdty: '',
      shodagesng: 1,
      shprctes: '',
      customerID: '',
      maluerID: '',
      shmodtya: '',
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
        },
      },
    }
  },
  created () {
    // 从缓冲中获取用户的token
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 轮播图
    this.$axios.post('app/sysbannberListAll',this.$qs.stringify({
      TYPE: 'sysmallbanner',
      DATA_VALUE: '0',
      showCount: '100',
      currentPage: '1',
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.shtaorin = res.data.varList;
    })
    .catch(() => {
      console.log('获取失败');
    });
    // 分类
    this.$axios.post('app/shangchengPageJgq',this.$qs.stringify({
      showCount: '100',
      currentPage: '1',
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.shmodtya = res.data.varList;
      document.querySelector('.shopmall-casion').style.width = Math.ceil(res.data.varList.length / 2) * 25 + '%';
    })
    .catch(() => {
      console.log('获取失败');
    });
    // 商品
    this.$axios.post('wx/mall/page',this.$qs.stringify({
      showCount: '6',
      currentPage: this.shodagesng,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.shcomdty = res.data.varList;
      this.shprctes = res.data.page.totalPage;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    // 滚动条触底的时候触发
    BaCoScrollqb(e) {
      // 滚动条卷起的高度
      let scrollTop = e.target.scrollTop;
      let scrollHeight = e.target.scrollHeight;
      let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
      let currentHeight = scrollTop + offsetHeight;
      if(currentHeight - scrollHeight >= 0 && this.shodagesng < this.shprctes){
        this.shodagesng = this.shodagesng + 1;
        // 滚动条触底的时候渲染新的数据
        this.$axios.post('wx/mall/page',this.$qs.stringify({
          showCount: '6',
          currentPage: this.shodagesng,
          MALL_TYPE: this.maluerID
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          this.shcomdty = [...this.shcomdty,...res.data.varList];
        })
        .catch(() => {
          // console.log('未登录获取数据失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/shopmall.css";
</style>